<template>
  <div id="create">
    <div class="row">
      <div class="col-12">
        <h4 class="font-weight-bold">Nuevo Registro de Normativa</h4>
      </div>
      <div class="col-12 mt-3">
        <form class="row" v-on:submit.prevent="createNormativity">
          <div class="col-12 form-group">
            <label for="title">Título</label>
            <input type="text"
              name="title"
              id="title"
              class="form-control"
              placeholder="Ingresa un título"
              v-model="$v.form.title.$model">
            <template v-if="$v.form.title.$error">
              <div class="invalid-feedback" v-if="!$v.form.title.required">Este campo es obligatorio</div>
            </template>
          </div>
          <div class="col-12 form-group">
            <label for="content">Contenido</label>
            <textarea type="text"
              name="content"
              id="content"
              class="form-control"
              placeholder="Contenido de la normativa"
              cols="10"
              v-model="$v.form.content.$model">
            </textarea>
            <template v-if="$v.form.content.$error">
              <div class="invalid-feedback" v-if="!$v.form.content.required">Este campo es obligatorio</div>
            </template>
          </div>
          <div class="col-12">
            <hr>
          </div>
          <div class="col-12 col-lg-6 form-group">
            <label for="title">Categoría</label>
            <select name="category"
              id="category"
              class="form-control"
              v-model="$v.form.category.$model">
              <option v-for="category in categories"
                v-bind:key="category.id"
                v-bind:value="category.id">
                {{category.name}}
              </option>
            </select> 
            <template v-if="$v.form.category.$error">
              <div class="invalid-feedback" v-if="!$v.form.category.required">Este campo es obligatorio</div>
            </template>
          </div>
          <div class="col-12 col-lg-6 form-group">
            <label for="year">Año</label>
            <input type="text"
              name="year"
              id="year"
              class="form-control"
              placeholder="2021"
              v-model="$v.form.year.$model">
            <template v-if="$v.form.year.$error">
              <div class="invalid-feedback" v-if="!$v.form.year.required">Este campo es obligatorio</div>
              <div class="invalid-feedback" v-if="!$v.form.year.minLength || !$v.form.year.maxLength">Proporciona un año válido</div>
            </template>
          </div>
          <div class="col-12">
            <hr>
          </div>
          <div class="col-12 form-group">
            <label for="link">Enlace - Archivo - Anexo</label>
            <input type="text"
              name="link"
              id="link"
              class="form-control"
              placeholder="http://"
              v-model="$v.form.link.$model">
            <template v-if="$v.form.link.$error">
              <div class="invalid-feedback" v-if="!$v.form.link.url">Ingrese una URL válida</div>
            </template>
          </div>
          <div class="col-12 text-right">
            <input type="submit" value="Guardar normativa" class="btn btn-success px-4">
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { validationMixin, } from "vuelidate";
  import { required, minLength, maxLength, url, } from "vuelidate/lib/validators";
  import { firestore, } from '@/firebase';
  export default {
    mixins: [
      validationMixin,
    ],
    data() {
      return {
        form: {
          title: "",
          content: "--- Sin contenido ---",
          category: "",
          link: "",
          year: "",
        },
        categories: [],
      };
    },
    validations: {
      form: {
        title: { required, },
        content: { required, },
        category: { required, },
        year: { required, minLength: minLength(4), maxLength: maxLength(4), },
        link: { url, }
      }
    },
    methods: {
      async getNormativityCategories() {
        try {
          this.categories = [];
          const snapshot = await firestore.collection("/normativity-categories").get();
          snapshot.forEach(doc => {
            this.categories.push({ ...doc.data(), id: doc.id, });
          });
        } catch(e) {
          console.error(e);
        }
      },
      async createNormativity() {
        this.$v.form.$touch();

        if (this.$v.form.$anyError)
          return;

        const {
          title,
          content,
          category,
          link,
          year,
        } = this.form;

        const updates = {
          title,
          content,
          category,
          link,
          year,
          createdBy: this.$store.state.user.uid,
          createdAt: new Date(),
        };

        try {
          await firestore.collection("/normativities").add(updates);
          setTimeout(() => this.$router.replace({ name: "Normativity", }), 500);
          this.$swal("Operación exitosa", "Normativa agregada con éxito", "success");
        } catch(e) {
          console.error(e);
          this.$swal("Error", e.toString(), "error");
        }
      },
    },
    created() {
      this.getNormativityCategories();
    }
  };
</script>